// @ts-check

if (!customElements.get("ff-accordion")) {
  class FfAccordion extends HTMLElement {
    constructor() {
      super();
      
      this.isMobile = Number(this.dataset.ffCollapsibleTabsBreakpoint) > window.innerWidth;

      if (this.isMobile) {
        this.ffInit();
      } else {
        this.ffReset();
      }

      return;
    }

    ffInit = () => {
      const triggers = this.querySelectorAll("[data-ff-collapsible-tab-trigger]");
      const contents = this.querySelectorAll("[data-ff-collapsible-tab-content]");

      for (let i = 0; i < triggers.length; i++) {
        triggers[i].previousElementSibling?.classList.add('ff-d-none');
        const trigger = triggers[i];
        const content = contents[i];
        
        // Set initial state
        // @ts-ignore
        content.style.height = '0';
        // @ts-ignore
        content.style.overflow = 'hidden';
        // @ts-ignore
        content.style.transition = 'height 0.3s ease';
        
        // Set initial SVG state (closed - show arrow down)
        // @ts-ignore
        trigger.children[0].style.display = 'inline'; // arrow-down
        // @ts-ignore
        trigger.children[1].style.display = 'none'; // arrow-up
        
        trigger.addEventListener('click', () => {
          // @ts-ignore
          if (content.style.height === '0px' || content.style.height === '0') {
            // Open
            // @ts-ignore
            content.style.height = content.scrollHeight + 'px';
            trigger.classList.add('ff-collapsible-tab-active');
            content.classList.add('ff-collapsible-tab-active');
            
            // Show arrow up, hide arrow down
            // @ts-ignore
            trigger.children[0].style.display = 'none'; // arrow-down
            // @ts-ignore
            trigger.children[1].style.display = 'inline'; // arrow-up
          } else {
            // Close
            // @ts-ignore
            content.style.height = '0';
            trigger.classList.remove('ff-collapsible-tab-active');
            content.classList.remove('ff-collapsible-tab-active');
            
            // Show arrow down, hide arrow up
            // @ts-ignore
            trigger.children[0].style.display = 'inline'; // arrow-down
            // @ts-ignore
            trigger.children[1].style.display = 'none'; // arrow-up
          }
        });
      }
    };

    ffReset = () => {
      const contents = this.querySelectorAll("[data-ff-collapsible-tab-content]");
      
      for (let i = 0; i < contents.length; i++) {
        const content = contents[i];
        
        // Reset to normal state
        // @ts-ignore
        content.style.height = '';
        // @ts-ignore
        content.style.overflow = '';
        // @ts-ignore
        content.style.transition = '';
        content.classList.remove('ff-collapsible-tab-active');
      }
      
      const triggers = this.querySelectorAll("[data-ff-collapsible-tab-trigger]");
      for (let i = 0; i < triggers.length; i++) {
        triggers[i].classList.add('ff-d-none');
        triggers[i].classList.remove('ff-collapsible-tab-active');
        
        // Reset SVG state
        // @ts-ignore
        triggers[i].children[0].style.display = 'inline'; // arrow-down
        // @ts-ignore
        triggers[i].children[1].style.display = 'none'; // arrow-up
      }
    };
  }

  customElements.define("ff-accordion", FfAccordion);
}

// @ts-ignore
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    requestAnimationFrame(() => {
      /**
       * @type {NodeListOf<HTMLElement>}
       */
      const navigators = document.querySelectorAll("ff-accordion");
      navigators.forEach((tabs) => {
        // @ts-ignore
        tabs.ffInit();
      });
    });
  });
}